var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"course-info-window",staticClass:"info-window hidden"},[(_vm.updateCard)?_c('course-card',{attrs:{"course":_vm.course},on:{"enroll":_vm.enroll}}):_vm._e()],1),_vm._v(" "),_c('div',{ref:"mapContainer",staticStyle:{"height":"80vh"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }